export { default } from "./ClaimProcessingCard";
